var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02876 3.90503H7.97063C7.46983 3.90503 7.06396 4.3109 7.06396 4.8117C7.06396 5.3125 7.46983 5.71836 7.97063 5.71836H8.02876C8.52956 5.71836 8.93543 5.3125 8.93543 4.8117C8.93543 4.3109 8.52956 3.90503 8.02876 3.90503Z",
    fill: "#6763B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02925 6.68262H7.97112C7.47038 6.68262 7.06445 7.08855 7.06445 7.58928V11.1882C7.06445 11.689 7.47038 12.0949 7.97112 12.0949H8.02925C8.52999 12.0949 8.93592 11.689 8.93592 11.1882V7.58928C8.93592 7.08855 8.52999 6.68262 8.02925 6.68262Z",
    fill: "#6763B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM8 14.9147C4.1872 14.9147 1.08533 11.8128 1.08533 8C1.08533 4.1872 4.1872 1.08533 8 1.08533C11.8128 1.08533 14.9147 4.1872 14.9147 8C14.9147 11.8128 11.8128 14.9147 8 14.9147Z",
    fill: "#6763B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionInfo);
export default __webpack_public_path__ + "static/media/transaction-info.e85f368dce5ac98dd77dc1bba99da503.svg";
export { ForwardRef as ReactComponent };